import { Icon, Label, Link, Spinner, Stack, Text } from '@fluentui/react';

import useEditingForm from './useEditingForm';
import useEmployee from './useEmployee';

export default ({ horizontal }: { horizontal?: boolean }) => {
  const labels: { title: string; value?: string; onEditClick?: any }[] = [
    { title: "Satış Temsilcisi", ...useEmployee() },
    { title: "Düzenlenen Form", ...useEditingForm() },
  ];

  return (
    <Stack.Item>
      <Stack wrap horizontal={horizontal} tokens={stackTokens}>
        {labels.map((l) =>
          l.value ? (
            <Stack.Item grow key={l.title}>
              <Label>{l.title}</Label>
              <Text>{l.value}</Text>{" "}
              {l.onEditClick && (
                <Link onClick={l.onEditClick}>
                  <Icon iconName="EditSolid12" />
                </Link>
              )}
            </Stack.Item>
          ) : (
            <Spinner
              key={l.title}
              label={l.title + " Yükleniyor"}
              labelPosition="right"
            />
          )
        )}
      </Stack>
    </Stack.Item>
  );
};

const stackTokens = { childrenGap: 10 };
